import React, { useEffect } from "react";
import PropTypes from "prop-types";
import CssBaseline from "@material-ui/core/CssBaseline";
import { withRouter } from "react-router-dom";
import {isHamburguerMenu}from '../../utils/objectManipulations'
import Footer from "../Footer";
import MainAppBar from "./MainAppBar";
import Menu from "./Menu";
import useStyles from "./styles";
import Dialog from "./../../containers/Dialog";

import {
  isPushNotificationSupported,
  isSubscribed,
  should_ask_notifications_permission,
} from "./../../push-notifications";

function AppContainer({
  notifications,
  authenticated,
  children,
  user,
  user: { login, mainGroup },
  menus,
  actions,
  getSettings,
  branches,
  getNotifications,
  setAllowanceDialog
  
}) {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);



  useEffect(() => {
    if(["farmer", "driver"].indexOf(mainGroup) !== -1) {
      // calling all notifications in this case
      getNotifications();
    }

    const subscribeToPushNotification = async () => {
      if (isPushNotificationSupported) {
        if (Notification.permission === "denied") {
          return;
        } else {
          if (Notification.permission !== "granted" || !isSubscribed(login)) {
            if (!should_ask_notifications_permission()) {
              return;
            }
            return setAllowanceDialog();
          }
        }
      }
    };
    subscribeToPushNotification();
  }, [
    getSettings,
    getNotifications,
    setAllowanceDialog,
    login,
    branches,
    mainGroup
  ]);

  if (!authenticated || !user) {
    return children;
  }

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  return (
    <>
      <div className={classes.root} id="scrollableDiv">
        <CssBaseline />
        <Menu
          user={user}
          actions={actions}
          menus={menus}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
        <main className={
          isHamburguerMenu(user.mainGroup) ? 
          classes.content : 
          classes.notHamburguer
        }>
          <MainAppBar
            notifications={notifications}
            user={user}
            menus={menus}
            handleDrawerToggle={handleDrawerToggle}
            
          />
          {children}
          <Footer authenticated={authenticated} />
        </main>
        <Dialog />
      </div>
    </>
  );
}

AppContainer.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  actions: PropTypes.array,
  menus: PropTypes.array.isRequired,
  children: PropTypes.object.isRequired,
};

AppContainer.defaultProps = {
  user: null,
  authenticated: true,
  actions: [],
  menus: [],
};

export default withRouter(AppContainer);
